module.exports = __webpack_public_path__ + "static/ПОЛОЖЕНИЕ об  аттестации госслужащих.doc";